import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'shared/components';
import { FormattedMessage } from 'react-intl';
import { ReactInternetSpeedMeter } from 'react-internet-meter';

import theme from './NoInternetPage.scss';


const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onRestore: PropTypes.func.isRequired,
};

const defaultProps = {};

const NoInternetPage = ({ intl, onRestore }) => (
  <div className={ theme.root }>
    <Icon name="no_connection" className={ theme.icon } />
    <div className={ theme.firstLine }>
      <FormattedMessage
        id="NoInternetPage.FirstLine"
        defaultMessage="** No internet connection"
      />
    </div>
    <div className={ theme.secondLine }>
      <FormattedMessage
        id="NoInternetPage.SecondLine"
        defaultMessage="** Check the Wi-Fi connection, router or network cable"
      />
    </div>
    <Button
      testId="reload-page-button"
      label={ intl.formatMessage({
        id: 'NoInternetPage.RefreshButton.Label',
        defaultMessage: 'Try again',
      }) }
    />
    {/*<div className={ theme.hidden }>*/}
    {/*  <ReactInternetSpeedMeter*/}
    {/*    pingInterval={ 3000 }*/}
    {/*    thresholdUnit="megabyte" // "byte" , "kilobyte", "megabyte"*/}
    {/*    imageUrl="https://static.elevate.ummanu.health/test/test.png"*/}
    {/*    downloadSize="106496"*/}
    {/*    callbackFunctionOnNetworkDown={ onRestore }*/}
    {/*    callbackFunctionOnNetworkTest={ onRestore }*/}
    {/*  />*/}
    {/*</div>*/}
  </div>
);

NoInternetPage.propTypes = propTypes;
NoInternetPage.defaultProps = defaultProps;

export default NoInternetPage;
